import { Page } from "components/page/page.component";
import { Text } from 'components/text/text.component'
import { View } from "components/view/view.component";
import style from './indicatorRangeAlertConfig.style.module.css'
import { Skeleton } from "components/skeleton";
import { Select, SelectItem } from "components/select/select.component";
import { TextInput } from "components/textInput/textInput.component";
import { Button } from "components/button/button.component";
import { useEffect, useState } from "react";
// import { useGetBuildingsApi } from "api/building.api";
import { useNavigation } from "services/navigation.service";
import { useGetCompanyIndicatorsApi } from "api/company.api";
import { useGetIndicatorRangeAlertConfigApi, useSaveNewIndicatorRangeAlertConfigApi, useUpdateIndicatorRangeAlertConfigApi } from "api/alertConfig.api";
import { IndicatorRangeAlertConfigInput } from "model/indicatorRangeAlertConfig.model";

type IndicatorRangeAlertConfigPageProps = {
    companyId: string,
    configId?: string,
}
export function IndicatorRangeAlertConfigPage({companyId, configId }: IndicatorRangeAlertConfigPageProps){
    // const {search} = useNavigation()
    // const {predio} = search
    // const buildingId: string | undefined = typeof predio === 'string' ? predio : undefined

    // const [building, setBuilding] = useState<string | undefined>( buildingId)
    const [indicator, setIndicator] = useState<string | undefined>('')
    const [minValue, setMinValue] = useState<number | undefined>()
    const [maxValue, setMaxValue] = useState<number | undefined>()
    // const {data:buildings, loading: loadingBuildings, get: getBuildings} = useGetBuildingsApi(companyId)
    const {loading: loadingIndicators, get: getIndicators, data: indicators} = useGetCompanyIndicatorsApi(companyId ?? '')

    const {loading: loadingSaveNew, saveNew, error: ErrorSaveNew} = useSaveNewIndicatorRangeAlertConfigApi()
    const {loading: loadingUpdate, update, error: ErrorUpdate} = useUpdateIndicatorRangeAlertConfigApi()
    const {loading: loadingConfig, get: getConfig} = useGetIndicatorRangeAlertConfigApi()

    const {goBack} = useNavigation()

    useEffect(()=>{
        getIndicators().catch(()=>{})
        // getBuildings().catch(()=>{})
        if(configId) { 
            getConfig(configId)
            .then(_config => {
                setIndicator(_config?.indicator.id)
                if(_config?.min) setMinValue(_config.min)
                if(_config?.max) setMaxValue(_config.max)
            })
            .catch(() => { alert('Erro ao recuperar configuração')})
        }
    // eslint-disable-next-line
    },[])

    function handleMinValueChange(newValue: number){
        setMinValue(newValue)
    }

    function handleMaxValueChange(newValue: number){
        setMaxValue(newValue)
    }

    function handleGoBack(){
        goBack()
    }

    async function handleSave(){
        // if(!building) {alert('Selecione ao menos um prédio'); return;}
        if(!indicator) {alert('Selecione ao menos um indicador'); return;}
        if(!minValue && !maxValue) {alert('Selecione valor de mínimo ou máximo'); return;}
        alert('Tudo ok para salvar')

        const config: IndicatorRangeAlertConfigInput = {
            indicatorId: indicator,
            companyId: companyId,
            // buildingId: building,
            min: minValue,
            max: maxValue
        }

        if(configId) await update(configId, config).catch(error => alert('Erro ao salvar configuração'))
        else await saveNew(config).catch(error => alert('Erro ao salvar configuração'))
    }

    return <Page title={'Configuração de Alerta'} menu header >
        <View className={style.Content}>
            <View className={style.FormContainer}>
                <View className={style.Form}>
                    
                    <View className={style.FormItemContainer}>
                        <Text type='h4'>Indicador</Text>
                        {loadingSaveNew || loadingUpdate || loadingIndicators
                        ? <Skeleton color='bg3'/>
                        : <Select disabled={loadingSaveNew || loadingUpdate || !!configId } size='small' fullWidth value={indicator} onChange={e => setIndicator(e.target.value)} >
                            {indicators?.alertIndicators?.map(_ => <SelectItem key={_.id} value={_.id}>{_.name}</SelectItem>)}
                        </Select>
                        }
                    </View>

                    {/* <View className={style.FormItemContainer}>
                        <Text type='h4'>Prédio</Text>
                        {loadingSaveNew || loadingUpdate || loadingBuildings
                        ? <Skeleton color='bg3'/>
                        : <Select disabled={loadingSaveNew || loadingUpdate || !!configId } size='small' fullWidth value={building} onChange={e => setBuilding(e.target.value)} >
                            <SelectItem key={''} value={undefined}>{'Nenhum Prédio'}</SelectItem>
                            {buildings?.map(_ => <SelectItem key={_.id} value={_.id}>{_.name}</SelectItem>)}
                        </Select>
                        }
                    </View> */}
                    
                    <View className={style.FormItemContainer}>
                        <Text type='h4'>{`Mínimo:`}</Text>
                        {loadingSaveNew || loadingUpdate || loadingIndicators
                        ? <Skeleton color='bg3'/>
                        : <TextInput type='number' disabled={loadingSaveNew || loadingUpdate } size='small' value={minValue} onChange={e => handleMinValueChange(parseFloat(e.target.value))} />
                        }
                    </View>

                    <View className={style.FormItemContainer}>
                        <Text type='h4'>{`Máximo:`}</Text>
                        {loadingSaveNew || loadingUpdate 
                        ? <Skeleton color='bg3'/>
                        : <TextInput type='number' disabled={loadingSaveNew || loadingUpdate } size='small' value={maxValue} onChange={e => handleMaxValueChange(parseFloat(e.target.value))} />
                        }
                    </View>
                </View>
            </View>
            <View className={style.Buttons}>
                <Button onClick={handleGoBack}>Voltar</Button>
                <Button disabled={loadingSaveNew || loadingUpdate} loading={loadingSaveNew || loadingUpdate} variant='contained' onClick={handleSave}>Salvar</Button>
            </View>
        </View>
    </Page>
}